import { Model_ConfigurationGet, Model_LabelAndReferenceGet } from "src/backend/openapi/v1";
import { configuratorPageK } from "src/translation-hooks/configurator-page";

export const TABS = {
  CONFIGURATIONS: { label: configuratorPageK.configurations, value: "CONFIGURATIONS" },
  PRODUCTS: { label: configuratorPageK.products, value: "PRODUCTS" }
} as const;

export const FILTER_WIDTH = { OPEN: 350, CLOSE: 40 };

export const PRODUCT_INFO_DIALOG_WIDTH = 400;

export const getProjectLineItemsHierarchy = <T extends Model_ConfigurationGet["projectLineItems"]>(projectLineItems: T): T => {
  if (projectLineItems && projectLineItems.length > 0) {
    const map = new Map(projectLineItems.map(projectLineItem => [projectLineItem.projectLineItemId, projectLineItem]));
    const result = [] as unknown as T;
    const visited = new Set<string>();

    function visit(id: string): void {
      if (visited.has(id)) return;
      visited.add(id);
      const item = map.get(id);
      if (!item) return;
      if (item.parentProjectLineItemId !== null) visit(item.parentProjectLineItemId || "");
      result.push(item);
    }

    projectLineItems.forEach(projectLineItem => visit(projectLineItem.projectLineItemId || ""));
    return result;
  }
  return [] as unknown as T;
};

export const getLabelsForEntity = (labels: Model_LabelAndReferenceGet[] = [], entityId: string) => {
  return labels.filter(label => {
    return label.references.findIndex(reference => reference.entityId === entityId) >= 0;
  });
};
